<form [formGroup]="questionForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Добавление вопроса</h3>
  <div mat-dialog-content>
    <div class="upload-image-box" *ngIf="url">
      <img [src]="url">
    </div>
    <mat-form-field>
      <mat-label>Вопрос</mat-label>
      <textarea matInput formControlName="text"
                placeholder="Введите вопрос"
                autofocus="autofocus"
                cdkFocusInitial
                cdkTextareaAutosize
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="5"></textarea>
    </mat-form-field>
    <mat-radio-group formControlName="type" *ngIf="testType!=='ISTQB'">
      <mat-radio-button *ngFor="let questionType of questionTypes"
                        value="{{questionType.id}}"
                        matTooltip="{{questionType.description}}">
        {{questionType.name}}
      </mat-radio-button>
    </mat-radio-group>
    <div class="min-max-controls" *ngIf="isMultipleAnswerSelected()">
      <mat-form-field>
        <mat-label>Минимальное количество ответов</mat-label>
        <input matInput type="number" min="0" formControlName="minAnswers" placeholder="0">
        <mat-error *ngIf="questionForm.controls.minAnswers.hasError('min')">
          Значение не может быть меньше 0
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Максимальное количество ответов</mat-label>
        <input matInput type="number" min="0" formControlName="maxAnswers" placeholder="Например, 3">
        <mat-error *ngIf="questionForm.controls.maxAnswers.hasError('min')">
          Значение не может быть меньше 0
        </mat-error>
        <mat-error *ngIf="questionForm.controls.maxAnswers.hasError('minGreaterThanMax')">
          Минимум не может быть больше максимума
        </mat-error>
      </mat-form-field>
    </div>
    <mat-radio-group formControlName="category" *ngIf="testType=='ISTQB'">
      <mat-radio-button *ngFor="let category of categories | keyvalue"
                        value="{{category.key}}"
                        matTooltip="{{category.value}}">
        {{category.value}}
      </mat-radio-button>
    </mat-radio-group>
    <div>
      <label>Добавить изображение к вопросу</label>
      <br />
      <input #imageInput
             type="file"
             accept="image/*"
             (change)="uploadImageFile(imageInput)">
      <button mat-icon-button
              *ngIf="url"
              (click)="deleteLoadedImage()">
        <mat-icon style="display: inline">delete</mat-icon>
      </button>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Добавить
    </button>
  </div>
</form>
